import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const CollectionsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 3L12.02 14.1C11.34 13.52 10.48 13.25 9.52 13.25C7.08 13.25 5.25 15.08 5.25 17.5C5.25 19.92 7.08 21.75 9.52 21.75C11.96 21.75 13.75 19.92 13.75 17.5V7.25H18.25V3H12ZM9.52 19.75C8.32 19.75 7.52 18.95 7.52 17.5C7.52 16.05 8.32 15.25 9.52 15.25C10.72 15.25 11.52 16.05 11.52 17.5C11.52 18.95 10.72 19.75 9.52 19.75Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default CollectionsIcon;
